/**
 * 根據裝置類型回傳對應的響應式圖片檔案名稱
 * @param baseName - 圖片基礎檔名（不含副檔名）
 * @returns 完整的圖片檔案名稱
 */

export function useImagePath() {
  const { isTablet, isDesktop } = useScreen();

  const provideResponsiveImgName = (baseName: string): string => {
    if (isDesktop.value) {
      return `${baseName}.webp`;
    }
    if (isTablet.value) {
      return `${baseName}_m.webp`;
    }
    return `${baseName}_s.webp`;
  };

  return {
    provideResponsiveImgName,
  };
}
